export default {
  setGroups(state, groups) {
    state.groups = groups;
  },
  setGroupsfilter(state, groupsFilter) {
    state.groupsFilter = groupsFilter;
  },
  setGroup(state, group) {
    state.group = group;
  },
  setPagination(state, pagination) {
    state.pagination = pagination;
  }
};
